<template>
  <hic-index-page v-loading="meta.loading" :title="isEmbed ? '' : '费用'" header-height="6rem" hide-footer>
    <template slot="buttons">
      <el-button :disabled="!condition.patient" type="primary" size="small" icon="el-icon-plus" @click.native="inFee('费用录入')">补 费</el-button>
      <!-- <el-button type="danger" size="small" icon="el-icon-minus" @click.native="inFee('退费')">退 费</el-button> -->
    </template>
    <template slot="search">
      <el-date-picker v-if="tabName == 'fees'" @change="dateChange" style="width: 16rem" size="small" v-model="condition.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      <el-date-picker v-if="tabName == 'dayFee'" @change="dateChange" style="width: 8rem" size="small" v-model="condition.date" type="date" placeholder="记账日期"></el-date-picker>
      <el-select v-if="!isEmbed" v-model="condition.patient" value-key="id" placeholder="请选择患者" @change="page" clearable size="small" class="left-pad">
        <el-option v-for="item in patients" :key="item.id" :label="item.patientName" :value="item"></el-option>
      </el-select>
      <el-input v-if="tabName != 'arrears'" class="condition-wide left-pad" v-model="condition.keyword" placeholder="项目编码、名称" size="small" @clear="page" v-on:keyup.enter.native="page" clearable>
        <el-button slot="append" icon="el-icon-search" @click.native="page"></el-button>
      </el-input>
    </template>
    <template slot="extend">
      <el-tabs v-model="tabName" @tab-click="page">
        <el-tab-pane label="费用记录列表" name="fees"></el-tab-pane>
        <el-tab-pane label="每日费用清单" name="dayFee" v-if="isEmbed"></el-tab-pane>
        <el-tab-pane label="欠费患者清单" name="arrears" v-if="!isEmbed"></el-tab-pane>
      </el-tabs>
    </template>
    <FeeList v-if="tabName == 'fees'" :condition="condition" :entity="entity"></FeeList>
    <DayFee v-if="tabName == 'dayFee'" :condition="condition" :entity="entity"></DayFee>
    <Arrears v-else-if="tabName == 'arrears'" :condition="condition" :entity="entity"></Arrears>

    <!-- <FeeDialog :visible.sync="meta.showFee" :title="selTitle" @close="page" /> -->
    <feeEnter :visible.sync="meta.showFee" :title="selTitle" :infoDetail="entity || condition.patient"></feeEnter>
 

  </hic-index-page>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      entity: Object, // 住院记录
    },
    components: {
      feeEnter: () => import("./feeEnter.vue"),
      FeeList: () => import("./_feeList.vue"),
      DayFee: () => import("./_dayFee.vue"),
      Arrears: () => import("./_arrears.vue"),
      // FeeDialog: () => import("./feeManage.vue"),
    },
    data() {
      return {
        title: "",
        meta: {
          loading: false,
          showFee: false,
        },
        tabName: "fees",
        condition: {
          keyword: null,
          hospitalizationId: null,
          billingDateStart: null,
          billingDateEnd: null,
          patient: null,
        },
        patients: [],
        freeBeds: [],
        transferPatinent: {},
        selTitle: "",
        isSelPatient:true
      };
    },
    computed: {
      ...mapGetters(["dict", "Enum", "user"]),
      isEmbed() {
        // 是否是嵌入模式
        return this.$route.path != "/fee";
      },
    },
    watch: {
      entity() {
        if (this.entity) {
          this.condition.patient = this.entity;
        } else {
          this.condition.patient = null;
        }
        this.page();
      },
    },
    mounted() {
      if (!this.isEmbed) {
        api.Hospitalization.query({ deptCode: this.user.deptCode, state: "已入住" }).then((res) => {
          this.patients = res.items;
        });
      }
      if (this.entity) {
        this.condition.patient = this.entity;
      }
      this.page();
    },
    methods: {
      page() {
        this.condition = this.$utils.Obj.clone(this.condition);
      },
      dateChange(v) {
        if (v) {
          if (Array.isArray(v)) {
            this.condition.billingDateStart = this.$utils.Fmt.datetimeStart(v[0]);
            this.condition.billingDateEnd = this.$utils.Fmt.datetimeEnd(v[1]);
          } else {
            this.condition.billingDateStart = this.$utils.Fmt.datetimeStart(v);
            this.condition.billingDateEnd = this.$utils.Fmt.datetimeEnd(v);
          }
        } else {
          this.condition.billingDateStart = null;
          this.condition.billingDateEnd = null;
        }
        this.page();
      },
      inFee(title) {
        this.selTitle = title;
        this.meta.showFee = true;
      },
    },
  };
</script>
